<script lang="ts">
    import {Utils} from "./util";
    import {ASSET_URL, CYCLE_COLORS, translations} from "./config";
    import type {Community, Property, Region} from "./models/model";
    import MapSelect from "./old/Select.svelte";
    import type {Option} from "./models/option";
    import Map from "./components/map/Map.svelte";
    import Hover from "./components/map/Hover.svelte";
    import Sidebar from "./components/Sidebar.svelte";
    import type Color from "./components/map/Map.svelte";
    import {fade, fly} from 'svelte/transition';
    import { _ } from './services/i18n';

    import {tweened} from 'svelte/motion';
    import {bounceOut} from 'svelte/easing';
    import Accordion from "./components/Accordion.svelte";
    import SimpleSelectOptions from "./components/SimpleSelectOptions.svelte";
    import {onMount} from "svelte";

    const size = tweened(0, {
        duration: 1200,
        easing: bounceOut,
        delay: 0,

    });

    function animateSidebar() {

        size.set(1)
    }

    //export let  mapType;
    export let mapType: string = "";
    let showFilter = false;
    let hoverCommunity: Community | null;
    let mouseX = 0;
    let mouseY = 0;

    let mapRef:Map;

    let communityData: Community;

    let isPhoneSize: boolean;
    checkPhoneSize();


    let toggleRegionAccordion = false;
    let selectedRegion = 3; //TODO: define the default MFI Region!
    let regions: Region[] = [];
    let communities: { [key: string]: Community } = {};
    let regionOptions: Option[] = [];
    const properties = Utils.get<Property[]>('/api/api/mfi/public/properties/');

    let selectedPropertyAnswers: { [id: number]: object } = null;

    let selectedSearchCommunity: string;

    function handleClick(event:any) {
        //console.log("Clicked element:", event.target);
    }

    onMount(() => {
        /*
        if(!ready)
            return;
        const params = new URLSearchParams(window.location.search);
        if(params.get('selectedCommunity')){
            setTimeout(() => {
                selectedSearchCommunity = params.get('selectedCommunity'); // Replace 'yourParam' with the actual param name
            },3000)
        }

         */


            // window.addEventListener('click', handleClick);

            // Clean up the event listener when the component is destroyed
            // return () => {
            //     window.removeEventListener('click', handleClick);
            // };
        });


    //let filteredCommunities: Community[];
    let markings: { [key: string]: 'dotted' | 'striped' } = {};
    let fills: { [key: string]: Color } = {};
    let lastClicked: string | null = null; //path id that was clicked last before the current (active) one.

    let ready:boolean = false;

    //same cycle color for all:
   // let cycleColors = ["#56A8DD", "#56A8DD","#56A8DD", "#56A8DD","#56A8DD", "#56A8DD","#56A8DD", "#56A8DD","#56A8DD", "#56A8DD","#56A8DD", "#56A8DD" ];
    //let cycleColors = ["#8BADDC", "#6B99CD", "#4F7FB8", "#32639E", "#2F3353", "#4A7E83", "#4E7C67", "#6C8E51", "#A8B35B", "#C5C35A"];


    let cycleColors = CYCLE_COLORS;

    // question / answer filter

    //load communities during init process:
    prepareSelectedCommunities(true);
/*
    $: if(ready){
        const params = new URLSearchParams(window.location.search);
        if(params.get('selectedCommunity')){
            if(!selectedSearchCommunity){
              //  selectedSearchCommunity = params.get('selectedCommunity'); // Replace 'yourParam' with the actual param name
            }
            //setTimeout(() => {
            //})
        }
    }
*/
    $: if(!selectedSearchCommunity){

        if(mapRef){
           mapRef.resetMap();
        }

    }
    //(selectedPropertyAnswers || mapType == 'pact') &&
     $:   if ((mapType == 'pact') && !selectedSearchCommunity) {

            if(selectedPropertyAnswers){
                    // console.log("selectedPropertyAnswers set!!!");
                //     console.log(selectedPropertyAnswers);

            }else{

                  // console.log("mapType pact, without any filter");

            }

        } else {

            //fills = {};
            //markings = {};
        }

    //if community was selected from dropdown (search)
    $: if(selectedSearchCommunity){

        //console.log("selectedSearchCommunity ???? ", selectedSearchCommunity)

        const f:any = {};
        //console.log("selected id = ", selectedSearchCommunity);
        //console.log(communities);
        let c = communities[selectedSearchCommunity];
        //console.log(c);
        //reset current selection:
        //console.log(":::last",lastClicked);
        //TODO: set last clicked

        //XX no effect:
        /*
        let resultColor = '#fd3'; //'#EE716F';
        f[c.key] = resultColor;
       // fills = f;
       // fills = {...fills}
      */

       // console.log("mapRef = ", mapRef);
       // console.log("fills before2",f);
        if(mapRef){
         mapRef.setFillFromSearch(selectedSearchCommunity,f)

        }



        // console.log("fills",fills);

        //  communities.(c => c.key == selectedSearchCommunity);
        // setMarker(communities.find(c => c  == selectedSearchCommunity));

        //
        selectSearchResultCommunity();

    }




    function prepareSelectedCommunities(reset = false){

        filterCommunities(selectedPropertyAnswers || {}).then(communities => {
            // console.log("set marker for:",  communities);
            const f:any = {};
            const m:any = {};

            communityData = null; //reset current selected community
            // console.log("community results == ");
            // console.log(communities);

            let resultColor;
            if(mapType == 'full'){
                resultColor = '#ffffff';
            }if(mapType == 'pact'){
                resultColor = '#BBE0ED';
            }
            if(mapType == 'merged'){
                resultColor = '#ffffff';
            }

            if(communities){

            for (const c of communities) {
                // if (selectedQuestion && selectedAnswer != null)
                // 	f[c.key] = selectedAnswer ? '#575756' : '#F18030';
                if (mapType == 'full') {
                    f[c.key] = resultColor
                }
                else if(mapType == 'merged'){

                    if(c?.dateOfSignaturePact) {

                        if ((c?.cycles_count == 0 || c?.cycles_count == null)) {
                            f[c.key] = cycleColors[0];
                        } else if (c?.cycles_count > 0) {
                            f[c.key] = cycleColors[c?.cycles_count + 1]; // [c?.cycles_count-1]
                            //  console.log(`cycle color for ${c.key} is ${cycleColors[c?.cycles_count - 1]}`);
                        } else {
                            f[c.key] = resultColor; //fallback, but case should not be possible
                        }
                    }else if(c?.dateOfSignaturePilotPact && !c?.dateOfSignaturePact){
                        f[c.key]= cycleColors[1];
                    }else{
                        f[c.key] = resultColor; //fallback, but case should not be possible
                    }
                }
                // = pact:
                else {

                    if(c?.dateOfSignaturePact && c?.dateOfSignaturePilotPact) {
                        f[c.key] = "mixed";
                    }else{

                        if(c?.dateOfSignaturePact){
                            f[c.key] =  '#56A8DD'

                        }
                        else if(c?.dateOfSignaturePilotPact){

                            f[c.key]= '#49b170';

                        }else{
                            f[c.key] = resultColor //fallback, but case should not be possible
                        }

                    }


                    //calculate cycle color:
                    //if (c?.cycles_count > 0) {
                    //    f[c.key] = cycleColors[c?.cycles_count - 1];
                    //} else {
                    //    f[c.key] = resultColor; //fallback, but case should not be possible
                    //}

                }
            }
            }

           // filteredCommunities = communities;
            markings = m;
            fills = f;

            //console.log(":::prepareSelectedCommunities() Result ->", { markings:markings, fills:f});

            if(reset){
                //mapRef.setFillFromSearch();
            }


        });


    }

    async function selectSearchResultCommunity(){
        showFilter = false;
        communityData = await Utils.get(`/api/api/mfi/public/community/${selectedSearchCommunity}/questions`);

    }

    function setMarker(community:Community){



    }

    /** Cast to region */
    function r(r: any): Region {
        return r;
    }

    function checkPhoneSize() {
        const listener = (v:any) => {
            isPhoneSize = v.matches;
        }
        const mq = window.matchMedia("(max-width: 680px)");
        isPhoneSize = mq.matches;
        mq.addEventListener
            ? mq.addEventListener("change", listener)
            : mq.addListener(listener);
    }

    function communityHover(options: CustomEvent<{ key: string; e: MouseEvent }>) {
        mouseX = options.detail.e.pageX;
        mouseY = options.detail.e.pageY;

        hoverCommunity = communities[options.detail.key];
    }

    function communityUnhover(event: CustomEvent<string>) {
        hoverCommunity = null;
    }

    async function communityClicked(event: CustomEvent<string>) {

        showFilter = false
        communityData = await Utils.get(`/api/api/mfi/public/community/${event.detail}/questions`);
    }

    async function filterCommunities(propertyAnswers: { [id: number]: object } | any = null) {

        //console.log("filter communities with filter:", propertyAnswers);
        //console.log("selectedPropertyAnswers",propertyAnswers);

        let url = '/api/api/mfi/public/community';
        const params = [];

        //not needed for mfi right now
        if(propertyAnswers){
            for (const property of Object.keys(propertyAnswers)) {
                const value = propertyAnswers[property];
                if (property && value != null) {

                    let answer;

                    if (value.type == 'percentage') {

                        answer = `${value.type},${value.value.join(",")}`;

                    } else if (value.type == 'boolean') {

                        answer = `${value.type},${value.value ? '1' : '0'}`;

                    } else {

                        answer = `${value.type},${value.value}`;
                    }

                    params.push(`filter%5Bhas_answered%5D%5B${property}%5D=${answer}`);
                }
            }

        }

        if(mapType == 'pact'){

            params.push('filter%5BhasPact%5D=1');
        }

        params.push("isPaginated=0");

        // disabled for now, since the filtering logic changed
        // if (citizens != null) {
        // 	params.push(`&filter%5Bcitizens%5D=${citizens}`);
        // }
        //should be never null
        if (params.length == 0) {
            return [];
        }
        return Utils.get<Community[]>(`${url}?${params.join('&')}`);
    }

    Utils.get<Region[] | null>('/api/api/mfi/public/regions').then(async r => {

        console.log("region result",r);
        regions = r;

        if (regions == null)
            return;

        regionOptions = regions.map(r => ({
            label: Utils.chooseTranslation(r.name),
            value: r.id
        }));
       // console.log("set regionOptions", regionOptions)


        const comms:any = {};
        for (const region of regions) {
            for (const community of region.communities) {
                comms[community.key] = community;
            }
        }

        communities = comms;
        //filteredCommunities = Object.keys(communities).map(key => communities[key]);
        //console.log("filters for api");
        //console.log(filteredCommunities);

        //TODO!!!
        selectedRegion = regionOptions[1]?.value;
    });

    /** Map over all answers that are not disabled */
    /*
    function mapAnswers<T>(answers: Answer[], map: (question: string, value: boolean, additionalInfo: { [lang: string]: string }) => T): T[] {
        return answers
        .filter(a => !a.isDisabled)
        .map(a => map(Utils.chooseTranslation(a.property.name), a.value, a.inputValue));
    }

        */

    async function onCSVClick() {
        /* disabled for now!
        // STEP 1: Create a new workbook
        const wb = XLSX.utils.book_new();

        // color theme
        const orange = "F18030";
        const blue = "AAEAED";
        const blueFill = {fill: {fgColor: {rgb: blue}}};
        const orangeFill = {fill: {fgColor: {rgb: orange}}};
        const border = {style: "thin"};
        const bottomBorder = {border: {bottom: border}};

        const q = await questions;

        const questionAnswers = Object.keys(selectedQuestionAnswers)
        .map(id => {
        return [
            {v: Utils.chooseTranslation(q.find(q => q.id == id)?.name), t: "s", s: blueFill},
            {v: !!selectedQuestionAnswers[id], t: "b", s: blueFill}
        ] as [CellObject, CellObject];
    });
        const communityElections: CellObject[][] = filteredCommunities
        .map(c => [
            {v: Utils.chooseTranslation(c.name), t: "s", s: blueFill},
            {
        v: Utils.chooseTranslation(c.citizens < 3000 ? translations.voting.relative : translations.voting.proportional),
        t: "s",
        s: orangeFill
    },
        ]);

        const filterSheet: CellObject[][] = [
        [
            {v: Utils.chooseTranslation(translations.question), t: "s", s: {...blueFill, ...bottomBorder}},
            {v: Utils.chooseTranslation(translations.answer), t: "s", s: {...blueFill, ...bottomBorder}},
        ],
        ...questionAnswers,
        [], // empty row
        [
            {v: Utils.chooseTranslation(translations.community), t: "s", s: {...blueFill, ...bottomBorder}},
            {v: Utils.chooseTranslation(translations.voting.label), t: "s", s: {...orangeFill, ...bottomBorder}},
        ],
        ...communityElections
        ];
        const electionStart = questionAnswers.length + 3; // + 3 because of first header row, empty row and because it's 1 based (not 0)

        // add worksheets
        const ws = XLSX.utils.aoa_to_sheet(filterSheet);
        ws['!autofilter'] = {ref: `A${electionStart}:B${electionStart + communityElections.length}`};
        ws['!cols'] = [{width: 60}, {width: 40}];

        XLSX.utils.book_append_sheet(wb, ws, "Filters");

        // if community is selected, add questions sheet
        if (communityData) {
        const questions = mapAnswers(communityData.public_answers, (question, value, additionalInfo) => {
        const row: CellObject[] = [
            {v: question, t: "s", s: blueFill},
            {v: !!value, t: "b", s: blueFill},
        ];

        if (additionalInfo != null && Object.keys(additionalInfo).length > 0)
        row.push({v: Utils.extractText(Utils.chooseTranslation(additionalInfo)), t: "s", s: blueFill});

        return row;
    });

        const questionSheet: CellObject[][] = [
        [
            {v: Utils.chooseTranslation(translations.question), t: "s", s: {...orangeFill, ...bottomBorder}},
            {v: Utils.chooseTranslation(translations.answer), t: "s", s: {...orangeFill, ...bottomBorder}},
            {
        v: Utils.chooseTranslation(translations.additionalInfo),
        t: "s",
        s: {...orangeFill, ...bottomBorder}
    },
        ],
        ...questions
        ];

        const ws2 = XLSX.utils.aoa_to_sheet(questionSheet);
        ws2['!cols'] = [{width: 50}, {width: 15}, {width: 50}];
        XLSX.utils.book_append_sheet(wb, ws2, Utils.chooseTranslation(communityData.name));
    }

        // download
        XLSX.writeFile(wb, "statistics.xlsx");

        */
    }

</script>
<div id="svgmap-content" class="mfi-grid">
    <div id="svgmap-container" class="mfi-col">
        {#if isPhoneSize}


        {/if}

        <!--mobile version-->
        {#if isPhoneSize}

            <div class="phone-filters">

                <div class="region-wrapper">
                    <Accordion title="{$_('filter.selectRegion')}" bind:expanded={toggleRegionAccordion}>
                        <div slot="content">
                            <SimpleSelectOptions
                                    options={regionOptions}
                                    value={selectedRegion}
                                    on:valueChanged={(e) => {
                                            console.log("mobile map selected");
                                            console.log(e.detail.value);
                                            selectedRegion = e.detail.value;
                                            toggleRegionAccordion = false;
                                        }}
                            ></SimpleSelectOptions>
                        </div>

                    </Accordion>
                </div>

                {#await properties}
                    {Utils.chooseTranslation(translations.loadingQuestions)}
                {:then properties}

                          <span>

                               <Sidebar bind:selectedPropertyAnswers
                                        bind:selectedSearchCommunity
                                        isPhoneSize={true}
                                        propertyList={properties}
                                        communityData={communityData}>
                               <!--nested map inside sidebar, only for mobile -->
                                   <div class="mobile-map" slot="map">
                                       {#each regions as region}
                                            {#if r(region).id === selectedRegion}
                                                <Map path="{ASSET_URL}/assets/img/map_mfi_{r(region).id}.svg" {regions} {fills} bind:lastClicked bind:ready
                                                     on:communityClick={communityClicked}
                                                   />
                                            {/if}
                                       {/each}
                                   </div>
                               </Sidebar>
                        </span>
                {/await}
            </div>
            <!--mobile version end-->
        {:else}
            <Map path="{ASSET_URL}/assets/img/map_mfi.svg" {regions} {fills} bind:lastClicked bind:this={mapRef} bind:ready
                 on:communityClick={communityClicked} on:communityHover={communityHover}
                 on:communityUnhover={communityUnhover}/>
        {/if}
    </div>
    <div class="mfi-col">
        <!-- desktop version -->
        {#if !isPhoneSize}
            {#await properties}
                <!--{Utils.chooseTranslation(translations.loadingQuestions)}--> <!--loading text -->
            {:then properties}
                        <span in:fly="{{ x: 200, duration: 500 }}" style="display:flex; flex-direction:column; justify-content:space-between!important; /*height:100%;*/" >
                            <Sidebar bind:selectedPropertyAnswers
                                     bind:selectedSearchCommunity
                                     {mapType}
                                     {isPhoneSize}
                                     bind:showFilter={showFilter}
                                     propertyList={properties}
                                     communityData={communityData}
                            />
                        </span>
                <!--
                      propertyOptions={properties.map(q => ({
                                id: q.id,
                                label: String(Utils.chooseTranslation(q.name)),
                            }))}
                -->
            {/await}
        {/if}
        <!--desktop version end-->

        <!--
        <button id="csvButton" class="btn-brand"
        on:click={onCSVClick}>
            {Utils.chooseTranslation(translations.csv)}
        </button>
        -->
        <!--
        <button class="btn-brand"
        on:click={() => showPrint = true}>{Utils.chooseTranslation(translations.print)}</button>
        <div id="placeholder" style="display: {communityData ? 'none' : 'unset'}">
        <h2 id="placeholderText">
            {Utils.chooseTranslation(translations.placeholderText)}
        </h2>

        </div>
        <div class="legend">
        <Legend/>
        </div>
        -->
    </div>
</div>
<Hover {hoverCommunity} {mouseX} {mouseY}/>

<!--
{#if showPrint}
    {#await properties}
        {Utils.chooseTranslation(translations.loadingQuestions)}
    {:then properties}
        <Print {regions} {communityData} {fills} {markings} {lastClicked} {selectedPropertyAnswers}
               on:done={() => showPrint = false}/>
    {/await}
{/if}
-->

<style lang="scss">

  /* alternative way+
  :global(.rangeSlider.range .rangeHandle .rangeNub) {

  background-color: red !important;
}
  */


  .flex-column {
    display: flex;
    flex-direction: column;
    // align-items: start;
  }
/*
  .legend {
    margin-top: 2rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
  }
*/
  .phone-filters {
    //margin-top: 4.5rem;
    display: block;
  }

  :global(.mfi-btn) {

    font-size: 16px;
    text-align: center;
    font-weight: 700;
    border: none;
    border-radius: 5px;
    background: #56A8DD;
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #FFFFFF;
    text-decoration: none;

    margin-top: 20px;
    display: inline-block;

    -webkit-transition: opacity .45s cubic-bezier(0.25, 1, 0.33, 1), transform .45s cubic-bezier(0.25, 1, 0.33, 1), border-color .45s cubic-bezier(0.25, 1, 0.33, 1), color .45s cubic-bezier(0.25, 1, 0.33, 1), background-color .45s cubic-bezier(0.25, 1, 0.33, 1), box-shadow .45s cubic-bezier(0.25, 1, 0.33, 1);
    transition: opacity .45s cubic-bezier(0.25, 1, 0.33, 1), transform .45s cubic-bezier(0.25, 1, 0.33, 1), border-color .45s cubic-bezier(0.25, 1, 0.33, 1), color .45s cubic-bezier(0.25, 1, 0.33, 1), background-color .45s cubic-bezier(0.25, 1, 0.33, 1), box-shadow .45s cubic-bezier(0.25, 1, 0.33, 1);

    &:hover {

      color:white;
     // color: #054055;
      text-decoration: none;
      box-shadow: 0 20px 38px rgba(0, 0, 0, 0.16) !important;
      -ms-transform: translateY(-3px);
      transform: translateY(-3px);
      -webkit-transform: translateY(-3px);
    }

    &:focus {

      outline: none;
    }

  }

  .info-btn:disabled {
    // border-color: #F1803080;
  }

  .info-btn:active {
    //  background: #F18030;
  }

  .region-wrapper {

    position:relative;
    display: block;
    z-index:999;
    min-height:3rem;
    margin-bottom:1rem;
  }

  .mobile-map{

    position: relative;
    margin:2rem;
    z-index:10;

  }


</style>
